import { render } from "./OnboardingStep1.vue?vue&type=template&id=45cb4742"
import script from "./OnboardingStep1.vue?vue&type=script&lang=js"
export * from "./OnboardingStep1.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__